import { useAppSelector } from 'redux/use-hooks';
import {
    selectLockedBalance,
    selectPlantedLockedOPN,
} from 'redux/slices/tokens';
import { formatToken } from 'components/wallet/token-amount';

import { TokenType } from 'types';

import {
  AvvBalanceWrapper,
  AvvBalanceFlex,
  AvvBalance,
  AvvBalanceMount
} from './opn-card.style';

const OPNCard = ({ token }: { token: TokenType }) => {
    const lockedBalance = useAppSelector(selectLockedBalance);
  const plantedBalance = useAppSelector(selectPlantedLockedOPN);
  return (
    <AvvBalanceWrapper>
      <AvvBalanceFlex>
        <AvvBalance>Available Balance:</AvvBalance>
        <AvvBalanceMount>{formatToken(token.balance, 24)}</AvvBalanceMount>
      </AvvBalanceFlex>
      <AvvBalanceFlex>
        <AvvBalance>Locked Balance:</AvvBalance>
        <AvvBalanceMount>{formatToken(lockedBalance, 24)}</AvvBalanceMount>
      </AvvBalanceFlex>
      <AvvBalanceFlex>
        <AvvBalance>Planted Balance:</AvvBalance>
        <AvvBalanceMount>{formatToken(plantedBalance, 24)}</AvvBalanceMount>
      </AvvBalanceFlex>
    </AvvBalanceWrapper>
  );
};

export default OPNCard;
